import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    visibility: ",
        ";\n    transition: visibility 0.3s;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    max-height: ",
        ";\n    transition: max-height 0.15s ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    opacity: ",
        ";\n    transition: opacity 0.3s ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Ui } from "@silvertours/front-shared";
var IconButton = /*#__PURE__*/ styled(Ui.IconButton, {
    target: "e15c5ooz0"
})("fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";display:block;flex:none;");
var StyledDialog = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz1"
})("position:fixed;inset:0;top:", function(param) {
    var topPosition = param.topPosition;
    return topPosition;
}, "px;z-index:20;", function(param) {
    var show = param.show;
    return css(_templateObject(), show ? "visible" : "hidden");
});
var StyledDialogPanel = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz2"
})("display:flex;align-items:start;overflow:hidden;background-color:white;", function(param) {
    var show = param.show;
    return css(_templateObject1(), show ? "100%" : 0, show ? "ease-in" : "ease-out");
});
var BackgroundOverlay = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz3"
})("background-color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";position:relative;height:100%;inset:0;", function(param) {
    var show = param.show;
    return css(_templateObject2(), show ? 0.7 : 0, show ? "ease-in" : "ease-out");
});
var PanelContainer = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz4"
})("position:absolute;top:0;width:100%;z-index:20;max-height:100%;overflow-y:auto;");
var GridContainer = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz5"
})("display:grid;");
var FlexContainer = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz6"
})("display:flex;flex-direction:column;");
var StyledContent = /*#__PURE__*/ styled("div", {
    target: "e15c5ooz7"
})("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";flex:1;");
var CloseButton = /*#__PURE__*/ styled(Ui.IconButton, {
    target: "e15c5ooz8"
})("position:absolute;top:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";right:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[20];
}, ";");
export { BackgroundOverlay, CloseButton, FlexContainer, GridContainer, IconButton, StyledContent, StyledDialog, StyledDialogPanel, PanelContainer };
